module.exports = __webpack_public_path__ + "static/img/my_member_bg.a62c9980.png";